import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import AdaptiveTrait from '../../AdaptiveTrait';

export default class MenuPopup extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            headerHeight: null,
        };
    }

    static get propTypes() {

        return {
            children: PropTypes.any,
            header: PropTypes.any,
            className: PropTypes.string,
        };
    }

    componentDidMount() {

        const header = document.querySelector('body > header');
        if (header !== undefined) {

            const updateHeight = () => {

                const headerHeight = header.getBoundingClientRect().height;

                this.headerElement = header;
                this.setState({ headerHeight });
            };

            updateHeight();

            AdaptiveTrait.addResizeEvent(() => updateHeight());
        }
    }

    render() {

        const
            { headerHeight } = this.state,
            { children } = this.props,
            headerOffset = this.props.header === undefined
                ? headerHeight
                : 0;

        return (
            <div className={ css('fixed inset-0 bg-white z-index-topmost overflow-y-auto') } style={{ top: headerOffset }}>
                { this.renderHeader() }
                { children }
            </div>
        );
    }

    renderHeader() {

        const
            { header } = this.props,
            { headerHeight } = this.state;

        if (header === undefined)
            return null;

        return <div className={ css('w-full border-b-base') } style={{ height: headerHeight }}>{ header }</div>;
    }

}